<template>
    <div class="w-full">
        <div v-if="itemCurrent && itemCurrent.url">
            <div class="relative w-max">
                <img
                    v-img:group
                    loading="lazy"
                    :src="
                        itemCurrent.uploaded
                            ? itemCurrent.url.replace('large', 'normal')
                            : itemCurrent.url
                    "
                    :alt="itemCurrent.alt"
                    width="120"
                    height="120"
                    class="rounded-xl border-2 border-brand-blue object-cover block"
                />
                <a
                    class="absolute -top-2.5 -right-2.5 bg-brand-blue text-white h-5 rounded-full px-1.5 flex items-center justify-center shadow-md hover:bg-stack-primary transition-colors whitespace-nowrap font-semibold"
                    style="font-size: 9px"
                    :href="`/app/images/detail/${itemCurrent.id}`"
                    target="_blank"
                    rel="noopener"
                >
                    #{{ itemCurrent.id }}
                </a>
                <button
                    v-if="enabled"
                    class="absolute -bottom-2.5 -right-2.5 w-7 h-7 rounded-full bg-stack-primary text-white flex items-center justify-center shadow-md hover:scale-110 transition-transform"
                    @click="openNewImage"
                >
                    <pencil-icon class="w-3.5 h-3.5" />
                </button>
            </div>
        </div>

        <div v-else>
            <custom-tooltip v-if="enabled" border>
                <button
                    class="rounded-xl border-2 border-dashed border-brand-blue flex flex-col items-center justify-center gap-1.5 w-30 h-30 text-theme-muted hover:border-stack-primary hover:text-stack-primary transition-colors"
                    @click="openNewImage"
                >
                    <photo-icon class="w-10 h-10" />
                    <span class="text-xs font-medium">Agregar</span>
                </button>
                <template #tooltip>Agregar imagen</template>
            </custom-tooltip>
            <div
                v-else
                class="w-30 h-30 rounded-xl border-2 border-brand-blue flex items-center justify-center"
            >
                <span class="text-sm text-theme-muted">Sin imagen</span>
            </div>
        </div>

        <div>
            <image-selector
                v-model="isOpenSelectorImage"
                :enabled-create="enabledCreate"
                :default-filters="defaultFilters"
                :message="message"
                @input="onSelectImage"
            />
        </div>
    </div>
</template>

<script>
import { DEFAULT_IMAGE_URL } from "@/common/constants";

import PencilIcon from "@/components/icons/PencilIcon.vue";
import PhotoIcon from "@/components/icons/PhotoIcon.vue";
import ImageSelector from "@/components/utils/ImageSelector.vue";

export default {
    name: "ImageManage",
    components: { ImageSelector, PencilIcon, PhotoIcon },
    model: {
        prop: "itemCurrent",
        event: "change"
    },
    props: {
        itemCurrent: {
            type: Object,
            default: () => ({
                alt: "alt",
                id: 1,
                url: "",
                image: {
                    id: 1,
                    url: DEFAULT_IMAGE_URL,
                    alt: "Chaqueta de sudadera colegio montessori 2 kennedy Bogotá."
                }
            }),
            required: true
        },
        enabledCreate: {
            default: false,
            type: Boolean,
            required: false
        },
        enabled: {
            default: true,
            type: Boolean,
            required: false
        },
        defaultFilters: {
            default: () => ({}),
            type: Object,
            required: false
        },
        message: { default: () => "", type: String, required: false }
    },
    emits: ["change"],
    data: () => ({
        isOpenSelectorImage: false
    }),
    computed: {},
    watch: {},
    mounted() {},
    methods: {
        async openNewImage() {
            this.isOpenSelectorImage = true;
        },
        onSelectImage(image) {
            this.$emit("change", image);
        }
    }
};
</script>
